/*
  Notification utility - migrated from jwt-bch-frontend
*/

import { toast } from 'react-toastify'

class NOTIFICATION {
  notify (title, message, type = 'info') {
    const content = title ? `${title}: ${message}` : message
    const options = {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    }

    switch (type) {
      case 'success':
        toast.success(content, options)
        break
      case 'error':
      case 'danger':
        toast.error(content, options)
        break
      case 'warning':
        toast.warning(content, options)
        break
      default:
        toast.info(content, options)
    }
  }
}

export default NOTIFICATION
